import 'angular:locale/data:fr-FR';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "fr-FR";
